import React from 'react'
import { Spinner } from 'reactstrap'

const Loading = (props) => {
  return(
    <Spinner />
  )
}

export default Loading